<template>
    <div class="body" style="min-height: 500px">
        <div role="main" class="main">
            <template v-if="!listing">
                <div class="row" style="height: 500px;">
                    <div class="col-12 h-100 d-flex align-items-center justify-content-center">
                        <div class="d-flex flex-column">
                            <Spinner></Spinner>
                        </div>
                    </div>
                </div>
            </template>
            <template v-else>
                <router-view></router-view>
            </template>
        </div>
    </div>
</template>

<script>
import { viewMixin } from '@/mixins/viewMixin';
import Spinner from '@/components/common/Spinner';


export default {
    name: 'LevelThreeView',
    components: {
        Spinner,
    },
    mixins: [viewMixin],
    metaInfo() {
        return {
            title: this.metaInfoTitle
        }  
    },
    watch: {
        $route(to, from) {
            // When we go from lv3 to lv3 we need to refetch the listing
            if (to.path !== from.path) {
                this.fetchListing();
            }
            
        }
    },
    computed: {
        listing: function() {
            return this.$store.getters.getCurrentListing;
        },
        metaInfoTitle: function() {
            if (this.listing === undefined) {
                return "casafile - Ferienwohnungen Tessin";
            }

            let localizedName = this.$options.filters.localized(this.listing.localizedName);
            
            return `casafile - Ferienwohnungen Tessin: ${localizedName}, ${this.listing.address.street} ${this.listing.address.number}, ${this.listing.address.cap} ${this.listing.address.city}`
        }
    },
    methods: {
        fetchListing: function() {
            const objectId = this.$route.params.id;
            console.log("Getting listing with object Id " + objectId);
            
            
            this.$http.get(`/listings/objectId/${objectId}`).then(res => {
                if (res.data === undefined) {
                    console.log("ERROR FETCHING THE OBJ!");
                    this.$router.push("/not-found")
                } else {
                    this.$store.commit('setCurrentListing', res.data)
                    
                }
                
            }).catch(err => {
                console.log(err);
                this.$router.push("/not-found")
            })
        }
    },
    beforeRouteLeave (to, from, next) {
        console.log(`Called beforeRouteLeave: ${from.path} => ${to.path}`);
        this.$store.commit('setCurrentListing', undefined);
        return next();
    },
    mounted() {
        if (this.listing === undefined) {
            this.fetchListing();
        }
    }
}
</script>

<style scoped>

</style>